// angular
import { Injectable } from '@angular/core';

// addons
import { of, Observable, throwError } from 'rxjs';

// settings
import { settings } from '@configs';

@Injectable()
export class CacheService {
  private cacheKey = settings.appCacheKey;

  private get cache() {
    const cache = localStorage.getItem(this.cacheKey);

    return cache && JSON.parse(cache);
  }

  setToCache({ key, value }): Observable<any> {
    let cache = Object.freeze(this.cache);

    cache = {
      ...cache,
      [key]: value
    };

    localStorage.setItem(this.cacheKey, JSON.stringify(cache));

    return of(this.cache);
  }

  clearFromCache(key: string): Observable<any> {
    const cache = this.cache;

    delete cache[key];

    localStorage.setItem(this.cacheKey, JSON.stringify(cache));

    return of(this.cache);
  }

  clearCache(): Observable<void> {
    return of(localStorage.clear());
  }

  getCacheSlice(key: string) {
    return this.cache && this.cache[key];
  }

  chechCache(cacheKeys: string[]): Observable<any> {
    const cache = this.cache;
    let hasAllKeys = true;

    if (!cache) {
      return throwError('Cache is missing');
    }

    for (const key of cacheKeys) {
      if (!key.startsWith('organization') && cache[key] === undefined) {
        hasAllKeys = false;

        break;
      }
    }

    if (hasAllKeys) {
      return of(cache);
    } else {
      return throwError('Cache is not correct');
    }
  }
}
